class GeoLocationHelper {
  constructor() {
    this.cachedLocation = null;
  }

  /**
   * Get user's geo-location
   * @returns {Promise<Object>} Location data
   */
  async getLocation() {
    if (this.cachedLocation) {
      return this.cachedLocation;
    }

    const cached = localStorage.getItem('thinkmd_geo_location');
    if (cached) {
      this.cachedLocation = JSON.parse(cached);
      this.fetchFreshLocation();
      return this.cachedLocation;
    }
    return this.fetchFreshLocation();
  }

  /**
   * Fetch fresh geo-location from API
   * @returns {Promise<Object>} Location data
   */
  async fetchFreshLocation() {
    const response = await fetch('http://ip-api.com/json/', {
      method: 'GET'
    });

    if (response.ok) {
      const data = await response.json();
      
      if (data.status === 'success') {
        this.cachedLocation = {
          city: data.city || 'Unknown',
          region: data.regionName || 'Unknown',
          country: data.country || 'Unknown',
          country_code: data.countryCode || 'XX',
          latitude: data.lat,
          longitude: data.lon
        };
        localStorage.setItem('thinkmd_geo_location', JSON.stringify(this.cachedLocation));
        return this.cachedLocation;
      }
    }
    return this.getFallbackLocation();
  }

  /**
   * Get fallback location
   * @returns {Object} Fallback location
   */
  getFallbackLocation() {
    this.cachedLocation = {
      city: 'Unknown',
      region: 'Unknown',
      country: 'Unknown',
      country_code: 'XX'
    };
    return this.cachedLocation;
  }

  clearCache() {
    this.cachedLocation = null;
    localStorage.removeItem('thinkmd_geo_location');
  }
}

const geoLocationHelper = new GeoLocationHelper();
export default geoLocationHelper;
